"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _once = _interopRequireDefault(require("./once"));

var _computeTimezoneGroups = _interopRequireDefault(require("../helpers/computeTimezoneGroups"));

var _TimezoneAliases = _interopRequireDefault(require("../lists/TimezoneAliases"));

var _default = (0, _once.default)(function () {
  var timezoneAliases = (0, _TimezoneAliases.default)();
  return (0, _computeTimezoneGroups.default)(timezoneAliases);
});

exports.default = _default;
module.exports = exports.default;